module.exports = __webpack_public_path__ + "static/media/semis.f6464287.png";